<!--
 * @Author:
 * @Description: 接入配置管理-新增
-->
<template>
  <el-dialog
    class="large-dialog"
    custom-class="add_config-dialog"
    width="1000px"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    v-dialogDrag
    @close="closeDialog"
  >
    <el-divider v-if="editType === 'edit'" />
    <el-form
      v-if="editType.value !== 'edit'"
      :model="chooseTypeForm"
      :rules="chooseTyperules"
      label-width="150px"
      ref="chooseType"
    >
      <el-row>
        <el-col>
          <el-form-item prop="protocolType" label="接口协议类型：">
            <el-select
              :disabled="editType === 'edit'"
              @change="changeInterfaceType"
              v-model="chooseTypeForm.protocolType"
              size="small"
              filterable
            >
              <el-option
                v-for="item in protocolTypeOptions"
                :key="item.id"
                :value="item.id"
                :label="item.sourceName"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col>
          <el-form-item prop="remark" label="接口协议描述：">
            <el-input
              :disabled="editType === 'edit'"
              v-model="protocolDescrition"
              size="small"
              clearable
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
    </el-form>
    <el-form
      :model="sourceForm"
      :rules="sourceRules"
      label-position="right"
      label-width="150px"
      ref="sourceFormRef"
    >
      <el-row>
        <el-col>
          <el-form-item label="数据源名称：" prop="dataSourceName">
            <el-input
              v-model="sourceForm.dataSourceName"
              size="small"
              clearable
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <!-- pi start -->
      <template v-if="chooseTypeForm.protocolType === 7">
        <el-row>
          <el-col>
            <el-form-item prop="pidbServer" label="Pi数据库地址：">
              <el-input
                v-model="sourceForm.pidbServer"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="pidbPort" label="PI数据库端口：">
              <el-input
                v-model="sourceForm.pidbPort"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="trustConnect" label="信任登录：">
              <el-switch
                v-model="sourceForm.trustConnect"
                :inactive-value="1"
                :active-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="sourceForm.trustConnect !== 0">
          <el-col>
            <el-form-item prop="userName" label="用户名：">
              <el-input
                v-model="sourceForm.userName"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="password" label="密码：">
              <el-input
                v-model="sourceForm.password"
                type="password"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <!-- <el-form-item prop="status" label="采集状态">
          <el-switch v-model="sourceForm.status"></el-switch>
        </el-form-item> -->
      </template>
      <!-- IEC104 start -->
      <template v-if="chooseTypeForm.protocolType === 6">
        <el-row>
          <el-col>
            <el-form-item prop="slaveIp" label="从机IP：">
              <el-input
                v-model="sourceForm.slaveIp"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="slavePort" label="从机端口：">
              <el-input
                v-model="sourceForm.slavePort"
                type="number"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="interrogationCycle" label="召唤周期：">
              <el-input
                v-model="sourceForm.interrogationCycle"
                type="number"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="generalInterrogationCycle" label="总召唤周期：">
              <el-switch
                v-model="sourceForm.generalInterrogationCycle"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item prop="status" label="采集状态">
          <el-switch v-model="sourceForm.status"></el-switch>
        </el-form-item> -->
      </template>
      <!-- IEC104 end -->
      <!-- modbus start-->
      <template v-if="chooseTypeForm.protocolType === 4">
        <el-row>
          <el-col>
            <el-form-item prop="masterType" label="通讯类型：">
              <el-select
                class="w-full"
                v-model="sourceForm.masterType"
                size="small"
                clearable
                filterable
              >
                <el-option
                  v-for="item in messageTypes"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col>
            <el-form-item prop="byteOrder" label="字节顺序:">
              <el-select
                class="w-full"
                v-model="sourceForm.byteOrder"
                size="small"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in strNumberList"
                  :key="index"
                  :value="item"
                  :label="item"
                ></el-option>
              </el-select> </el-form-item
          ></el-col> -->
        </el-row>

        <el-row>
          <el-col>
            <el-form-item prop="slaveId" label="从机ID：">
              <el-input
                v-model="sourceForm.slaveId"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="overTime" label="通讯超时时间(ms):">
              <el-input
                v-model="sourceForm.overTime"
                size="small"
                type="number"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item prop="minPeriod" label="最小通讯周期(ms):">
              <el-input
                v-model="sourceForm.minPeriod"
                size="small"
                type="number"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="collectCycle" label="采集周期(s):">
              <el-input
                v-model="sourceForm.collectCycle"
                type="number"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>

        <el-divider content-position="left">TCP 通讯设置</el-divider>
        <el-row>
          <el-col>
            <el-form-item prop="ip" label="IP地址(从机)：">
              <el-input v-model="sourceForm.ip" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="port" label="端口(从机)：">
              <el-input
                v-model="sourceForm.port"
                type="number"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>

        <el-divider content-position="left">串口通讯设置</el-divider>
        <el-row>
          <el-col>
            <el-form-item prop="serialPortName" label="串口名：">
              <el-input
                v-model="sourceForm.serialPortName"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="baudRate" label="波特率：">
              <el-input
                v-model="sourceForm.baudRate"
                type="number"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item prop="dataBits" label="数据位：">
              <el-input
                v-model="sourceForm.dataBits"
                type="number"
                size="small"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="parity" label="校验位：">
              <el-select
                class="w-full"
                type="number"
                v-model="sourceForm.parity"
                size="small"
                clearable
                filterable
              >
                <el-option
                  v-for="item in parityTypes"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="stopBits" label="停止位：">
              <el-select
                class="w-full"
                type="number"
                v-model="sourceForm.stopBits"
                size="small"
                clearable
                filterable
              >
                <el-option
                  v-for="item in stopBitsTypes"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <!-- modbus end -->
      <template v-if="chooseTypeForm.protocolType === 1 || chooseTypeForm.protocolType === 2">
        <el-row>
          <el-col>
            <el-form-item label="服务器IP：" prop="ip">
              <el-input v-model="sourceForm.ip" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="服务器名称：" prop="hostName">
              <el-input
                v-model="sourceForm.hostName"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
      </template>
      <template v-if="chooseTypeForm.protocolType === 1">
        <el-row>
          <el-col>
            <el-form-item label="IP：" prop="opcDaIp">
              <el-input
                v-model="sourceForm.opcDaIp"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item label="用户名：">
              <el-input v-model="sourceForm.username" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="密码：">
              <el-input
                v-model="sourceForm.password"
                size="small"
                clearable
                type="password"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="progId：" prop="progId">
              <el-input
                v-model="sourceForm.progId"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="clsId：">
              <el-input v-model="sourceForm.clsId" size="small" clearable></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item label="Item前缀：">
              <el-input v-model="sourceForm.itemPrefix" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="Item后缀：">
              <el-input v-model="sourceForm.itemSuffix" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else-if="chooseTypeForm.protocolType === 2">
        <el-row>
          <el-col>
            <el-form-item label="OPC主机URL：" prop="opcUrl">
              <el-input v-model="sourceForm.opcUrl" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="安全模式：" prop="safetyMode">
              <el-radio-group v-model="sourceForm.safetyMode">
                <el-radio :label="0">None</el-radio>
                <el-radio :label="1">Sign</el-radio>
                <el-radio :label="2">Sign&Encyrpty</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="安全策略：" prop="securityPolicy">
              <el-radio-group v-model="sourceForm.securityPolicy">
                <el-radio :label="0">None</el-radio>
                <el-radio :label="1">Basic128Rsa15</el-radio>
                <el-radio :label="2">Basic256Sha256</el-radio>
                <el-radio :label="3">Basic256</el-radio>
                <el-radio :label="4">Basic128sha256</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="用户名：">
              <el-input v-model="sourceForm.username" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="密码：">
              <el-input
                v-model="sourceForm.password"
                size="small"
                clearable
                type="password"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="Item前缀：">
              <el-input v-model="sourceForm.itemPrefix" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="Item后缀：">
              <el-input v-model="sourceForm.itemSuffix" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else-if="chooseTypeForm.protocolType === 'opc-plc'">
        <el-form-item label="品牌：" prop="brand">
          <el-select
            class="w-full"
            v-model="sourceForm.brand"
            size="small"
            disabled
            clearable
            filterable
          >
            <el-option
              v-for="item in brandList.list"
              :key="item.id"
              :label="item.sourceTypeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备IP：" prop="brandIp">
          <el-input v-model="sourceForm.brandIp" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备ID：" prop="brandDeviceId">
          <el-input v-model="sourceForm.brandDeviceId" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="数据接收IP：" prop="receivedIp">
          <el-input v-model="sourceForm.receivedIp" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="数据接收端口：" prop="receivedPort">
          <el-input-number
            :controls="false"
            v-model="sourceForm.receivedPort"
            :min="0"
            class="w-full"
          ></el-input-number>
        </el-form-item>
      </template>
      <template v-if="chooseTypeForm.protocolType === 1 || chooseTypeForm.protocolType === 2">
        <el-row>
          <el-col>
            <el-form-item label="采集周期(s)：" prop="collectCycle">
              <el-input-number
                :controls="false"
                v-model="sourceForm.collectCycle"
                placeholder="默认值：5"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="collectType" label="数据轮询方式：">
              <el-select
                v-model="sourceForm.collectType"
                size="small"
                clearable
                filterable
                class="w-full"
              >
                <el-option label="轮询模式" :value="0"></el-option>
                <el-option label="订阅模式" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else-if="chooseTypeForm.protocolType === 'udp'">
        <el-row>
          <el-col>
            <el-form-item prop="ip" label="UDP IP：">
              <el-input
                v-model="sourceForm.ip"
                size="small"
                clearable
                placeholder="请输入UDP IP"
              ></el-input></el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="port" label="UDP Port：">
              <el-input
                v-model="sourceForm.port"
                size="small"
                clearable
                placeholder="请输入UDP Port"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
      </template>
      <template v-if="chooseTypeForm.protocolType === 'snmp'">
        <el-row>
          <el-col>
            <el-form-item prop="version" label="协议版本：">
              <el-select
                :disabled="editType === 'edit'"
                v-model="sourceForm.version"
                size="small"
                filterable
              >
                <el-option
                  v-for="item in snmpTypes"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item v-if="sourceForm.version !== 3" prop="v2Community" label="Community">
              <el-input
                v-model="sourceForm.v2Community"
                size="small"
                clearable
                placeholder="请输入Community"
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="oidPrefix" label="oid前缀">
              <el-input
                v-model="sourceForm.oidPrefix"
                size="small"
                clearable
                placeholder="请输入oid前缀"
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="oidSuffix" label="oid后缀">
              <el-input
                v-model="sourceForm.oidSuffix"
                size="small"
                clearable
                placeholder="请输入oid后缀"
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="collectCycle" label="采集周期(s):">
              <el-input
                v-model="sourceForm.collectCycle"
                type="number"
                size="small"
                clearable
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="ip" label="IP地址：">
              <el-input
                v-model="sourceForm.ip"
                size="small"
                clearable
                placeholder="请输入IP地址"
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="port" label="端口：">
              <el-input
                v-model="sourceForm.port"
                size="small"
                clearable
                placeholder="请输入端口"
              ></el-input> </el-form-item
          ></el-col>
          <el-col v-if="sourceForm.version === 3">
            <el-form-item prop="v3UserName" label="用户名：">
              <el-input
                v-model="sourceForm.v3UserName"
                size="small"
                clearable
                placeholder="请输入用户名"
              ></el-input> </el-form-item
          ></el-col>
          <el-col v-if="sourceForm.version === 3">
            <el-form-item prop="v3AuthProtocol" label="认证协议：">
              <el-select
                :disabled="editType === 'edit'"
                v-model="sourceForm.v3AuthProtocol"
                size="small"
                filterable
              >
                <el-option
                  v-for="item in v3AuthProtocolTypes"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
                ></el-option> </el-select></el-form-item
          ></el-col>
          <el-col v-if="sourceForm.version === 3">
            <el-form-item prop="v3AuthPassword" label="认证密码：">
              <el-input
                v-model="sourceForm.v3AuthPassword"
                size="small"
                clearable
                placeholder="请输入认证密码"
              ></el-input> </el-form-item
          ></el-col>
          <el-col v-if="sourceForm.version === 3">
            <el-form-item prop="v3PrivProtocol" label="隐私协议：">
              <el-select
                :disabled="editType === 'edit'"
                v-model="sourceForm.v3PrivProtocol"
                size="small"
                filterable
              >
                <el-option
                  v-for="item in v3PrivProtocolTypes"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col v-if="sourceForm.version === 3">
            <el-form-item prop="v3PrivPassword" label="隐私密码：">
              <el-input
                v-model="sourceForm.v3PrivPassword"
                size="small"
                clearable
                placeholder="请输入隐私密码"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
      </template>
      <template v-if="chooseTypeForm.protocolType === 'iec102'">
        <el-row>
          <el-col>
            <el-form-item prop="slaveIp" label="从机IP：">
              <el-input
                v-model="sourceForm.slaveIp"
                size="small"
                clearable
                placeholder="请输入从机IP"
              ></el-input></el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="slavePort" label="从机端口：">
              <el-input
                v-model="sourceForm.slavePort"
                size="small"
                clearable
                placeholder="请输入从机端口"
              ></el-input> </el-form-item
          ></el-col>
          <el-col>
            <el-form-item prop="interrogationCycle" label="召唤周期：">
              <el-input
                v-model="sourceForm.interrogationCycle"
                size="small"
                clearable
                placeholder="请输入召唤周期"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
      </template>
      <el-row>
        <el-col>
          <el-form-item label="通讯超时时间(s)：" v-if="chooseTypeForm.protocolType === 'opc-plc'">
            <el-input-number
              :controls="false"
              v-model="sourceForm.overTime"
              placeholder="默认值：300"
              :min="0"
              class="w-full"
            ></el-input-number> </el-form-item
        ></el-col>
        <el-col>
          <el-form-item prop="localIp" label="数据源本地IP：">
            <el-input
              v-model="sourceForm.localIp"
              size="small"
              clearable
              placeholder="请输入数据源本地IP"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button
        v-if="chooseTypeForm.protocolType !== 6 && chooseTypeForm.protocolType !== 'udp'"
        size="small"
        type="success"
        @click="test()"
        >测试</el-button
      >
      <el-button size="small" type="primary" icon="iconfont icon-save" @click="save"
        >保存</el-button
      >
      <el-button size="small" icon="iconfont icon-close" @click="cancel()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import configManagementService from '@/services/configManagementService'
import { pick } from 'lodash'

export default {
  name: 'configureDataSourceAddDialog',

  props: {
    standardId: {
      type: String,
      default: '',
    },
    currentDetail: {
      type: Object,
      default: () => {
        return {
          visible: true,
          data: {},
        }
      },
    },
    currentData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    protocolTypeOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
    sourceType: {
      type: Number,
      default: 1,
    },
    editTypeProp: {
      type: String,
      default: 'edit',
    },
    visible: {
      type: Boolean,
    },
  },
  watch: {
    sourceType: {
      handler(val) {
        this.chooseTypeForm.protocolType = val
      },
      immediate: true,
    },
    editTypeProp: {
      handler(value) {
        if (value === 'edit') {
          // this.getCurrentDataSource()
          // this.chooseTypeForm = { protocolType: this.currentData.dataSourceDirectTypeName }
          // this.protocolDescrition = find(this.protocolTypeOptions, {
          //   sourceName: this.currentData.dataSourceDirectTypeName,
          // }).remark
          this.dialogTitle = '编辑配置'
          this.getConfigDetail()
        } else {
          this.dialogTitle = '新增接入配置'
        }
      },
      immediate: true,
    },
  },
  components: {},
  data() {
    return {
      protocolDescrition: '',
      sourceName: '',
      currentInterfaceType: '',
      sourceFormRef: '',
      dialogVisible: true,
      chooseTypeForm: {
        protocolType: '',
      },
      strNumberList: ['AB CD', 'CD AB', 'BA DC', 'DA BA'],
      dialogTitle: '',
      editType: '',
      currentSourceType: '',
      sourceTypeOptions: [
        {
          label: 'opc-da',
          value: 'opc-da',
        },
        {
          label: 'opc-plc',
          value: 'opc-plc',
        },
        {
          label: 'opc-ua',
          value: 'opc-ua',
        },
        {
          label: 'modbus',
          value: 'modbus',
        },
        {
          label: 'iec104',
          value: 'iec104',
        },
        {
          label: 'pidb',
          value: 'pidb',
        },
      ],
      chooseTyperules: {
        protocolType: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      sourceForm: {
        hostName: '',
        ip: '',
        byteOrder: '',
        dataSourceName: '',
        opcDaIp: '',
        username: '',
        password: '',
        progId: '',
        clsId: '',
        itemPrefix: '',
        opcUrl: '',
        itemSuffix: '',
        safetyMode: 0,
        securityPolicy: 0,
        brand: '',
        brandIp: '',
        brandDeviceId: '',
        receivedIp: '',
        receivedPort: 0,
        collectCycle: 1,
        overTime: 300,
        status: 1,
        collectType: 0,
        id: undefined,
        masterType: '',
        slaveId: 0,
        minPeriod: 0,
        port: 0,
        serialPortName: '',
        baudRate: 0,
        dataBits: 0,
        parity: 0,
        stopBits: 0,
        slaveIp: '',
        slavePort: 0,
        generalInterrogationCycle: 0,
        interrogationCycle: 0,
        pidbServer: '',
        pidbPort: '',
        trustConnect: null,
        userName: '',
        localIp: '', // 数据源本地ip
        version: 1,
        v2Community: '',
        oidPrefix: '',
        oidSuffix: '',
        v3UserName: '',
        v3AuthProtocol: '',
        v3PrivPassword: '',
        v3AuthPassword: '',
        v3PrivProtocol: '',
      },
      sourceRules: {
        byteOrder: [{ required: true, message: '必填', trigger: 'blur' }],
        hostName: [{ required: true, message: '必填', trigger: 'blur' }],
        ip: [{ required: true, message: '必填', trigger: 'blur' }],
        dataSourceName: [{ required: true, message: '必填', trigger: 'blur' }],
        opcDaIp: [{ required: true, message: '必填', trigger: 'blur' }],
        progId: [{ required: true, message: '必填', trigger: 'blur' }],
        opcUrl: [{ required: true, message: '必填', trigger: 'blur' }],
        safetyMode: [{ required: true, message: '必填', trigger: 'change' }],
        securityPolicy: [{ required: true, message: '必填', trigger: 'change' }],
        brand: [{ required: true, message: '必填', trigger: 'change' }],
        brandIp: [{ required: true, message: '必填', trigger: 'blur' }],
        brandDeviceId: [{ required: true, message: '必填', trigger: 'blur' }],
        receivedIp: [{ required: true, message: '必填', trigger: 'blur' }],
        receivedPort: [{ required: true, message: '必填', trigger: 'blur' }],
        collectCycle: [{ required: true, message: '必填', trigger: 'blur' }],
        overTime: [{ required: true, message: '必填', trigger: 'blur' }],
        collectType: [{ required: true, message: '必填', trigger: 'change' }],
        masterType: [{ required: true, message: '必填', trigger: 'change' }],
        slaveId: [{ required: true, message: '必填', trigger: 'blur' }],
        minPeriod: [{ required: true, message: '必填', trigger: 'blur' }],
        port: [{ required: true, message: '必填', trigger: 'blur' }],
        serialPortName: [{ required: true, message: '必填', trigger: 'blur' }],
        baudRate: [{ required: true, message: '必填', trigger: 'blur' }],
        dataBits: [{ required: true, message: '必填', trigger: 'blur' }],
        parity: [{ required: true, message: '必填', trigger: 'change' }],
        stopBits: [{ required: true, message: '必填', trigger: 'change' }],
        localIp: [{ required: true, message: '必填', trigger: 'blur' }],
        pidbServer: [{ required: true, message: '必填', trigger: 'blur' }],
        pidbPort: [{ required: true, message: '必填', trigger: 'blur' }],
        trustConnect: [{ required: true, message: '必填', trigger: 'blur' }],
        version: [{ required: true, message: '必填', trigger: 'blur' }],
        v2Community: [{ required: true, message: '必填', trigger: 'blur' }],
        v3UserName: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      messageTypes: [
        {
          label: 'Tcp',
          value: 1,
        },
        {
          label: 'Udp',
          value: 2,
        },
        {
          label: 'Rtu',
          value: 3,
        },
        {
          label: 'RtuOnTcp',
          value: 4,
        },
        {
          label: 'RtuOnUdp',
          value: 5,
        },
        {
          label: 'Ascii',
          value: 6,
        },
        {
          label: 'AsciiOnTcp',
          value: 7,
        },
        {
          label: 'AsciiOnUdp',
          value: 8,
        },
      ],
      parityTypes: [
        {
          label: 'None',
          value: 0,
        },
        {
          label: 'Old',
          value: 1,
        },
        {
          label: 'Even',
          value: 2,
        },
        {
          label: 'Mark',
          value: 3,
        },
        {
          label: 'Space',
          value: 4,
        },
      ],
      stopBitsTypes: [
        {
          label: 'None',
          value: 0,
        },
        {
          label: 'Old',
          value: 1,
        },
        {
          label: 'Two',
          value: 2,
        },
        {
          label: 'OnePointFive',
          value: 3,
        },
      ],
      v3PrivProtocolTypes: [
        {
          label: 'CBC-DES',
          value: 'CBC-DES',
        },
        {
          label: 'CFB-AES-128',
          value: 'CFB-AES-128',
        },
      ],
      v3AuthProtocolTypes: [
        {
          label: 'MD5',
          value: 'MD5',
        },
        {
          label: 'SHA',
          value: 'SHA',
        },
      ],
      snmpTypes: [
        {
          label: 'V1',
          value: 1,
        },
        {
          label: 'V2',
          value: 2,
        },
        {
          label: 'V3',
          value: 3,
        },
      ],
      modbusMasterType: false,
    }
  },
  methods: {
    getCurrentDataSource() {
      Object.assign(this.sourceForm, this.currentData)
    },
    // 新增协议接口类型改变
    changeInterfaceType(value) {
      this.currentInterfaceType = this.protocolTypeOptions.find((item) => {
        return item.id === value
      })
      console.log(value, this.protocolTypeOptions, this.currentInterfaceType, 'value')
      this.interfaceType = value
      this.dialogTitle = '新增接入配置'
      this.chooseTypeForm = { protocolType: value }
      this.$refs.sourceFormRef.resetFields()
    },
    // 取消
    cancel() {
      this.$emit('closeDataOriginDialog')
    },
    // 测试
    async test() {
      this.$refs.sourceFormRef.validate(async (valid) => {
        if (valid) {
          // let res = ''
          // let err = ''
          switch (this.chooseTypeForm.protocolType) {
            case 'opc-da':
              const opcDaReqData = pick(this.sourceForm, [
                'hostName',
                'ip',
                'dataSourceName',
                'opcDaIp',
                'username',
                'password',
                'progId',
                'clsId',
                'itemPrefix',
                'collectCycle',
                'overTime',
                'status',
                'collectType',
                'id',
                'localIp',
              ])
              opcDaReqData.status = opcDaReqData.status ? 0 : 1
              const [err, res] = await protocolOpcDaApi.connectTestUsingPOST2({
                body: opcDaReqData,
              })
              if (!err) {
                this.$message.success('测试成功')
              }
              break
            case 'opc-ua':
              const opcUaReqData = pick(this.sourceForm, [
                'collectCycle',
                'itemPrefix',
                'dataSourceName',
                'hostName',
                'ip',
                'password',
                'username',
                'opcUrl',
                'overTime',
                'safetyMode',
                'securityPolicy',
                'status',
                'collectType',
                'id',
                'localIp',
              ])
              opcUaReqData.status = opcUaReqData.status ? 0 : 1
              const [err1, res1] = await protocolOpcUaApi.connectTestUsingPOST3({
                body: opcUaReqData,
              })
              if (!err1) {
                this.$message.success('测试成功')
              }
              break
            case 'modbus':
              const modbusReqData = pick(this.sourceForm, [
                'id',
                'dataSourceName',
                'masterType',
                'slaveId',
                'overTime',
                'minPeriod',
                'collectCycle',
                'ip',
                'byteOrder',
                'port',
                'serialPortName',
                'baudRate',
                'dataBits',
                'stopBits',
                'parity',
                'status',
                'localIp',
              ])
              modbusReqData.status = modbusReqData.status ? 0 : 1
              const [err2, res2] = await protocolModbusApi.connectTestUsingPOST1({
                body: modbusReqData,
              })
              if (!err2) {
                this.$message.success('测试成功')
              }
              break
            case 'pidb':
              const pidReqData = pick(this.sourceForm, [
                'dataSourceName',
                'pidbServer',
                'pidbPort',
                'trustConnect',
                'userName',
                'password',
                'id',
                'localIp',
                'countPoint',
              ])
              // modbusReqData.status = modbusReqData.status ? 0 : 1
              const [err3, res3] = await protocolPidbApi.connectTestUsingPOST4({
                body: pidReqData,
              })
              if (!err3) {
                this.$message.success('测试成功')
              }
              break
            case 'iec104':
              const reqData = pick(this.sourceForm, [
                'id',
                'dataSourceName',
                'slaveIp',
                'slavePort',
                'interrogationCycle',
                'status',
                'generalInterrogationCycle',
                'localIp',
              ])
              reqData.status = reqData.status ? 0 : 1
              reqData.generalInterrogationCycle = reqData.generalInterrogationCycle ? 0 : 1
              const [err4, res4] = await protocolIEC104Api.connectTestUsingPOST({
                body: reqData,
              })
              if (!err4) {
                this.$message.success('测试成功')
              }
              break
            case 'iec102':
              const req102Data = pick(this.sourceForm, [
                'dataSourceName',
                'slaveIp',
                'slavePort',
                'interrogationCycle',
                'localIp',
              ])
              req102Data.dataSourceDirectId = this.currentInterfaceType.id
              req102Data.dataSourceDirectName = this.currentInterfaceType.sourceName
              req102Data.dataSourceDirectTypeName = this.currentInterfaceType.sourceTypeName
              const [err5, res5] = await protocolIEC102Api.connectTestUsingPOST({
                body: req102Data,
              })
              if (!err5) {
                this.$message.success('测试成功')
              }
              break
            case 'snmp':
              let snmpReqData
              if (this.sourceForm.version !== 3) {
                snmpReqData = pick(this.sourceForm, [
                  'id',
                  'dataSourceName',
                  'version',
                  'v2Community',
                  'oidPrefix',
                  'oidSuffix',
                  'collectCycle',
                  'ip',
                  'port',
                  'localIp',
                ])
              } else {
                snmpReqData = pick(this.sourceForm, [
                  'id',
                  'dataSourceName',
                  'version',
                  'collectCycle',
                  'oidPrefix',
                  'oidSuffix',
                  'ip',
                  'port',
                  'v3UserName',
                  'v3AuthProtocol',
                  'v3AuthPassword',
                  'v3PrivProtocol',
                  'v3PrivPassword',
                  'localIp',
                ])
              }
              const [err6, res6] = await protocolSnmpApi.connectTestUsingPOST6({
                body: snmpReqData,
              })
              if (!err6) {
                this.$message.success('测试成功')
              }
              break
            default:
              break
          }
        }
      })
    },
    // 新增、编辑保存
    save() {
      if (!this.chooseTypeForm.protocolType) {
        this.$message.warning('请先选择接口类型！')
        return
      }
      console.log(this.sourceForm, 'this.sourceForm')
      this.$refs.sourceFormRef.validate(async (valid) => {
        if (valid) {
          // 公共字段
          const params = {
            standardId: this.standardId,
            protocolType: this.chooseTypeForm.protocolType, // 接口协议类型
            protocolDescrition: this.protocolDescrition, // 接口协议描述
            dataSourceName: this.sourceForm.dataSourceName, // 数据源名称
            localIp: this.sourceForm.localIp, // 数据源本地IP
          }
          // 【Opc-Da： 1】【Opc-Ua： 2】【Modbus： 4】【IEC104： 6】【Pidb： 7】
          switch (this.chooseTypeForm.protocolType) {
            case 1:
              params.protocolOpcDa = pick(this.sourceForm, [
                // 'ip',
                'hostName',
                // 'opcDaIp',
                'username',
                'password',
                'progId',
                'clsId',
                'itemPrefix',
                'itemSuffix',
                'collectCycle',
                'collectType',
              ])
              params.protocolOpcDa.hostIp = this.sourceForm.ip
              params.protocolOpcDa.severIp = this.sourceForm.opcDaIp
              break
            case 2:
              params.protocolOpcUa = pick(this.sourceForm, [
                'hostName',
                'safetyMode',
                'securityPolicy',
                'username',
                'password',
                'itemPrefix',
                'itemSuffix',
                'collectCycle',
                'collectType',
              ])
              params.protocolOpcUa.hostIp = this.sourceForm.ip
              params.protocolOpcUa.severIp = this.sourceForm.opcUrl // OPC主机URL
              break
            case 4:
              params.protocolModbus = pick(this.sourceForm, [
                'masterType',
                'slaveId',
                'overTime',
                'minPeriod',
                'collectCycle',
                'serialPortName',
                'baudRate',
                'dataBits',
                'parity',
                'stopBits',
              ])
              params.protocolModbus.slaveIp = this.sourceForm.ip // IP地址(从机)
              params.protocolModbus.slavePort = this.sourceForm.port // 端口(从机)
              break
            case 6:
              params.protocolIec104 = pick(this.sourceForm, [
                'slaveIp',
                'slavePort',
                'interrogationCycle',
                'generalInterrogationCycle',
              ])
              break
            case 7:
              params.protocolPidb = pick(this.sourceForm, ['trustConnect', 'userName', 'password'])
              params.protocolPidb.ip = this.sourceForm.pidbServer // PI数据库地址
              params.protocolPidb.port = this.sourceForm.pidbPort // PI数据库端口
              break
            default:
              break
          }
          console.log(params, 'params')
          if (this.editTypeProp === 'create') {
            const res = await configManagementService.addCollectDataSourceConfig(params)
            if (res && res.code === 0) {
              this.$message.success('新增成功！')
              this.cancel()
              this.$refs.sourceFormRef.resetFields()
              this.$emit('closeDataOriginDialog')
            }
          } else if (this.editTypeProp === 'edit') {
            params.id = this.currentData.id
            const res = await configManagementService.updateCollectDataSourceConfig(
              this.currentData.id,
              params
            )
            if (res && res.code === 0) {
              this.$message.success('修改成功！')
              this.cancel()
              this.$refs.sourceFormRef.resetFields()
              this.$emit('closeDataOriginDialog')
            }
          }
        }
      })
    },
    // 获取详情
    async getConfigDetail() {
      const res = await configManagementService.getCollectDataSourceConfigDetail(
        this.currentData.id
      )
      if (res && res.code === 0) {
        // 公共字段
        this.chooseTypeForm.protocolType = res.data.protocolType
        this.protocolDescrition = res.data.protocolDescrition
        // 【Opc-Da： 1】【Opc-Ua： 2】【Modbus： 4】【IEC104： 6】【Pidb： 7】
        switch (res.data.protocolType) {
          case 1:
            this.sourceForm = res.data.protocolOpcDa
            this.sourceForm.ip = res.data.protocolOpcDa.hostIp
            this.sourceForm.opcDaIp = res.data.protocolOpcDa.severIp
            break
          case 2:
            this.sourceForm = res.data.protocolOpcUa
            this.sourceForm.ip = res.data.protocolOpcUa.hostIp
            this.sourceForm.opcUrl = res.data.protocolOpcUa.severIp
            break
          case 4:
            this.sourceForm = res.data.protocolModbus
            this.sourceForm.ip = res.data.protocolModbus.slaveIp
            this.sourceForm.port = res.data.protocolModbus.slavePort
            break
          case 6:
            this.sourceForm = res.data.protocolIec104
            break
          case 7:
            this.sourceForm = res.data.protocolPidb
            this.sourceForm.pidbServer = res.data.protocolPidb.ip
            this.sourceForm.pidbPort = res.data.protocolPidb.port
            break
          default:
            break
        }
        this.sourceForm.dataSourceName = res.data.dataSourceName
        this.sourceForm.localIp = res.data.localIp
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.$emit('closeDataOriginDialog')
    },
  },
}
</script>

<style lang="scss" scoped>

/deep/ .el-button--success {
  background-color: #67c23a !important;
}

</style>
<style>

.add_config-dialog .el-select {
  width: 100% !important;
}
.add_config-dialog .el-input-number {
  width: 100% !important;
}
.add_config-dialog .el-form .el-input {
  width: 100% !important;
}

</style>
